import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassengerDocsaInformationComponent } from './passenger-docsa-information.component';
import { AccordionModule } from '../accordion/accordion.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { InputSelectModule } from '../input-select/input-select.module';
import { DateRangeModule } from '../date-range/date-range.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [PassengerDocsaInformationComponent],
  imports: [
    CommonModule,
    AccordionModule,
    InputFieldModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InputSelectModule,
    DateRangeModule
  ],
  exports: [PassengerDocsaInformationComponent]
})
export class PassengerDocsaInformationModule {}
